import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../app/api/rp_api";
import {IRPStore} from "../../app/rp_reducer";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {getIgnoredNotifyResponse} from "../../store/utils/get_ignored_notify_response";
import {getAllRegionTypesFromStore} from "../utils/get_all_region_types_from_store";

const regionListApiLink = apiV2ListLink.region.list(Scenario.SEARCH_REGION_DETAIL);

export const getSelectedRegionBySlugApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getSelectedRegionBySlug: build.query<ISelectedRegion | null, {slug: string; country?: number}>({
            queryFn: async ({slug, country}, {getState}, _extraOptions, baseQuery) => {
                const allRegionTypeValues = getAllRegionTypesFromStore(getState() as IRPStore);
                const response = await baseQuery({
                    url: regionListApiLink,
                    params: {
                        slug,
                        country,
                        type: allRegionTypeValues
                    }
                });

                if (response.error) {
                    return {
                        error: getIgnoredNotifyResponse(response.error, [404])
                    };
                }

                const results = (response.data as {results?: ISelectedRegion[] | undefined})?.results;
                if (!results || results.length === 0) {
                    return {
                        data: null
                    };
                }

                return {
                    data: results[0]
                };
            }
        })
    })
});

export const {useGetSelectedRegionBySlugQuery, useLazyGetSelectedRegionBySlugQuery} = getSelectedRegionBySlugApi;
